import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';

const homeSEO = {
  title: '在线撸——随时随地在线撸的极致体验平台',
  description:
    '在线撸是当下最受欢迎的线上休闲互动方式，无需下载、即点即玩，随时随地享受在线撸带来的轻松乐趣。本平台汇聚海量在线撸内容，操作简单、流畅稳定，适合所有喜爱在线撸的用户，立即体验！',
  keywords: '在线撸,在线撸视频,在线撸猫,在线撸串,在线撸铁,在线撸代码,在线撸题',
  canonicalUrl: 'https://playrul.github.io/',
};

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '在线撸',
      url: 'https://playrul.github.io/',
      description:
        '在线撸是当下最受欢迎的线上休闲互动方式，无需下载、即点即玩，随时随地享受在线撸带来的轻松乐趣。',
      sameAs: ['https://weibo.com/zaixianlu', 'https://space.bilibili.com/zaixianlu'],
    },
    {
      '@type': 'WebSite',
      name: '在线撸',
      url: 'https://playrul.github.io/',
      description:
        '在线撸——随时随地在线撸的极致体验平台。汇聚视频、撸猫、撸串、撸铁、撸代码、撸题六大板块。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://playrul.github.io/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '在线撸首页',
      url: 'https://playrul.github.io/',
      isPartOf: { '@id': 'https://playrul.github.io/#website' },
      about: { '@id': 'https://playrul.github.io/#organization' },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '在线撸平台是什么？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '在线撸是一个综合性的线上休闲互动内容平台，汇集了在线撸视频、在线撸猫、在线撸串、在线撸铁、在线撸代码、在线撸题等六大内容板块。用户无需下载任何应用，打开网页即可随时随地享受轻松有趣的内容阅读体验。',
          },
        },
        {
          '@type': 'Question',
          name: '在线撸平台需要注册吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '目前在线撸平台完全免费开放，浏览所有内容无需注册登录。直接打开网站即可畅享全部内容。',
          },
        },
        {
          '@type': 'Question',
          name: '在线撸平台的内容多久更新一次？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '我们的编辑团队每日更新优质内容，确保用户每天都能看到新鲜有趣的文章和资讯。',
          },
        },
        {
          '@type': 'Question',
          name: '如何找到我感兴趣的内容分类？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '在首页即可看到六大分类入口，点击任一分类卡片即可进入对应的内容专区。',
          },
        },
        {
          '@type': 'Question',
          name: '在线撸平台有哪些特色功能？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '平台提供分类浏览、精选推荐、全文搜索等核心功能，支持面包屑导航和快捷回到顶部。',
          },
        },
        {
          '@type': 'Question',
          name: '我可以投稿或分享内容到在线撸平台吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '可以通过关于我们页面的联系方式提交合作意向，我们的内容团队会尽快与您取得联系。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title={homeSEO.title}
        description={homeSEO.description}
        keywords={homeSEO.keywords}
        canonicalUrl={homeSEO.canonicalUrl}
        ogImage="https://readdy.ai/api/search-image?query=Vibrant%20digital%20illustration%20of%20online%20entertainment%20platform%2C%20colorful%20geometric%20shapes%2C%20warm%20orange%20and%20coral%20gradient%2C%20playful%20energetic%20atmosphere%2C%20digital%20art%20style&width=1200&height=630&seq=og-home&orientation=landscape"
        schemaData={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <FAQSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}